import { isBrowser } from '@noths/polaris-client-utils';
/* istanbul ignore file */
import bunyan from 'bunyan';

import { serviceName } from 'src/settings';

export const logger = isBrowser()
  ? (console as unknown as bunyan)
  : bunyan.createLogger({
      name: serviceName,
    });
